export default __webpack_public_path__ + "static/media/D_02_01_bg.6afe8f7b.mp4";